// extracted by mini-css-extract-plugin
export default {"buttons_container":"_5-SimpleView_buttons_container__TdHN7"};